import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import { NAV_ITEMS } from '../../constants';
import MenuLink from './ui/MenuLink';


class Navigation extends Component {
  componentDidMount() {
    const jquery = window.$;
    new window.WOW().init();

    jquery('.animated-icon1').click((e) => {
      jquery('.animated-icon1').toggleClass('open');
    });
  }

  getNavLinkClass = (path) => {
   return this.props.location.pathname === path ? 'active' : '';
 }

  renderLinks() {
    return NAV_ITEMS.map(({ path, text, exact }) => {
      return (
        <li key={path} className={`nav-item ${this.getNavLinkClass(path)}`}>
          <MenuLink path={path} text={text} exact={exact} />
        </li>
      )
    });
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark elegant-color mb-4 fixed-top scrolling-navbar">
          <Link className="navbar-brand" to="/"><img src="/img/logo.png" alt="Fernan de Dios" /></Link>

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent"
              aria-expanded="false" aria-label="Toggle navigation"><div className="animated-icon1"><span></span><span></span><span></span></div></button>

          <div className="collapse navbar-collapse" id="navbarContent">
              <ul className="navbar-nav ml-auto">
                  {this.renderLinks()}
              </ul>
          </div>
      </nav>
    );
  }
}

export default withRouter(Navigation);
